import { ProductType } from '@/types';
import { getDefaultViewId } from './getDefaultViewId';

export const getView = (productType: ProductType, viewId = getDefaultViewId(productType)) =>
  productType.views.find(({ id }) => id === viewId);
